import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import NotificationBell from './Notifications/components/NotificationBell';
import CommunicationIconComponent from './CommunicationPopper/components/CommunicationIconComponent';
import { HeaderBar } from './headerComponents/HeaderBar';
import { HomeLogoButton } from './headerComponents/HomeLogoButton';
import { PlantAlarmTriggerControl } from './headerComponents/PlantAlarmTriggerControl';
import { ProfileMenuControl } from './headerComponents/ProfileMenuControl';
import { VatikaBadge } from './headerComponents/VatikaBadge';
import { useHeaderActions } from './headerComponents/useHeaderActions';
import { SCADA_RULES, anyPlant, useEnforcedCan } from '../access';

const actionsSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 1, md: 2 },
  minWidth: 0,
  marginInlineStart: 'auto',
};

export default function Header(): JSX.Element {
  const { isViewing, showVatikaLogo } = useHeaderActions();
  const canTriggerAlarms = useEnforcedCan(SCADA_RULES.actuate, anyPlant);

  return (
    <HeaderBar>
      <HomeLogoButton />
      <Box sx={actionsSx}>
        <PlantAlarmTriggerControl canOpen={canTriggerAlarms} />
        <NotificationBell key={String(isViewing)} />
        <CommunicationIconComponent />
        <ProfileMenuControl />
      </Box>
      {showVatikaLogo && <VatikaBadge />}
    </HeaderBar>
  );
}
